import { render, staticRenderFns } from "./BillManager.vue?vue&type=template&id=0cce905a&scoped=true"
import script from "./BillManager.vue?vue&type=script&lang=js"
export * from "./BillManager.vue?vue&type=script&lang=js"
import style0 from "./BillManager.vue?vue&type=style&index=0&id=0cce905a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cce905a",
  null
  
)

export default component.exports